import { IGroup } from "pages/[tenant]/g/@types";

export const removeDuplicatedItems = (list: IGroup[], item: IGroup) =>
  list.find((itemFromList) => itemFromList.id === item.id)
    ? [...list]
    : [...list, item];
